import { Component, OnInit } from '@angular/core';
import { projectInfo } from 'environments/version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  projectInfo = projectInfo;

  constructor() { }

  ngOnInit() {
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  noop(){};
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/footer/footer.component.ts